export const USER = "USER";
export const SERVICE_LIST = "SERVICE_LIST"